<script lang="ts">
  // server/browser/src/lib/ui/CopyUrl.svelte — truncated, click-to-copy URL.
  import { toasts } from "./toast.svelte";

  let { url, class: cls = "" }: { url: string; class?: string } = $props();

  let copied = $state(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      copied = true;
      toasts.ok("URL copied");
      window.setTimeout(() => (copied = false), 1200);
    } catch {
      toasts.error("Clipboard blocked — select the URL manually");
    }
  }
</script>

<button
  type="button"
  onclick={copy}
  title={`${url} — click to copy`}
  aria-label={`Copy URL ${url}`}
  class={`group inline-flex min-w-0 max-w-full items-center gap-1.5 rounded text-left ${cls}`}
>
  <span class="nums truncate text-xs text-ink-faint group-hover:text-ink-dim">{url}</span>
  <span
    class={`shrink-0 transition-colors ${copied ? "text-ok" : "text-ink-faint opacity-0 group-hover:opacity-100"}`}
    aria-hidden="true"
  >
    {#if copied}
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M20 6L9 17l-5-5" />
      </svg>
    {:else}
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="9" y="9" width="11" height="11" rx="2" />
        <path d="M5 15V5a2 2 0 0 1 2-2h10" />
      </svg>
    {/if}
  </span>
</button>
